<template>
  <div class="container-table-visibilidad">
    <q-card class="my-card">
      <q-card-section>
        <div class="row">
          <div class="col-12 container-app">
            <div class="row title-row">
              <div class="title" data-cy="visibility-title">Visibilidad</div>
            </div>
            <div class="content" style="margin-bottom: 32px">
              <q-toggle
                data-cy="visible-for-all-toggle"
                color="primary"
                v-model="visibilidadTodos"
                label="Visible para todos"
                left-label
                @input="updateVisibleForAll"
              />
            </div>

            <div
              data-cy="container-visibility"
              :class="visibilidadTodos ? 'block-action' : ''"
            >
              <div class="row title-row">
                <div class="title">Visibilidad limitada</div>
              </div>
              <div class="row">
                <div class="subtitle">
                  Visible para las empresas del listado
                </div>
              </div>
              <div class="row">
                <div class="col-12" style="padding-top: 37px">
                  <q-table
                    data-cy="visible-empresas-table"
                    :data="listExplotaciones"
                    :columns="columnsExplotaciones"
                    row-key="id"
                    :loading="isLoadingExplotaciones"
                    :pagination.sync="pagination"
                  >
                    <template v-slot:top-right>
                      <div style="margin-right: 44px">
                        <q-btn
                          data-cy="explotacion-add-btn"
                          color="primary"
                          label="Añadir Empresa"
                          @click="triggerSearchModal()"
                        />
                      </div>
                    </template>
                    <template v-slot:body-cell-acciones="props">
                      <q-td key="acciones" :props="props">
                        <q-icon
                          name="o_delete"
                          style="color: #002f6c; font-size: 24px; cursor: pointer;"
                          @click="triggerDeleteExplotacion(props.row)"
                          data-cy="delete-explotacion-btn"
                        />
                      </q-td>
                    </template>
                  </q-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
    </q-card>
    <DialogCreate
      v-model="showDialogSearchExplotacion"
      title="Visibilidad limitada"
      labelSuccess="Añadir"
      dataCy="add-explotacion-btn"
      cancelDataCy="cancel-explotacion-btn"
      @save="saveNewExplotacion()"
      :isLoading="isLoading"
    >
      <template slot="body">
        <div class="title-option text-center">
          Añada la empresa para la que es visible este ámbito
        </div>
        <div class="row q-col-gutter-md col-12">
          <div class="col-12">
            <q-select
              data-cy="select-explotacion"
              outlined
              use-input
              clearable
              hide-selected
              fill-input
              v-model="selectedExplotacion"
              :options="allExplotaciones"
              input-debounce="0"
              option-value="id"
              option-label="name"
              label="Explotación"
              class="col-5"
              @filter="filterFn"
            >
              <template v-slot:no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    Sin resultados
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
          </div>
        </div>
      </template>
    </DialogCreate>
    <DialogDelete
      v-if="selectedDeleteExplotacion"
      v-model="showModalDeleteExplotacion"
      :showIcon="true"
      :txtContainer="
        `¿Está seguro de eliminar la cuenta empresa ${selectedDeleteExplotacion.name} ?`
      "
      dataCy="confirm-delete-explotacion"
      @save="removeExplotacion()"
      :isLoading="isLoading"
    />
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import DialogDelete from '@/shared/dialogs/delete/DialogDelete.vue';
import Loading from '@/components/shared/mixins/Loading.js';

import { QCard, QCardSection, QToggle, QTable, QTd } from 'quasar';

export default {
  components: {
    QCard,
    QCardSection,
    QToggle,
    QTable,
    QTd,
    DialogCreate,
    DialogDelete
  },
  mixins: [Message, Loading],
  props: {
    dataAmbito: Object
  },
  computed: {},
  data () {
    return {
      data: this.dataAmbito,
      name: null,
      visibilidadTodos: true,
      showDialogSearchExplotacion: false,
      allExplotaciones: null,
      allExplotacionesOpts: null,
      allExplotacionesOptsFiltered: null,
      selectedExplotacion: null,
      listExplotaciones: [],
      showModalDeleteExplotacion: false,
      selectedDeleteExplotacion: null,
      isLoading: false,
      isLoadingExplotaciones: false,
      columnsExplotaciones: [
        {
          name: 'name',
          field: 'name',
          label: 'Nombre',
          align: 'left',
          sortable: true
        },
        {
          name: 'acciones',
          label: 'Acciones',
          align: 'center',
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: 4
      }
    };
  },
  async created () {
    await this.loadData();
  },
  mounted () {},
  beforeDestroy () {},
  methods: {
    async loadData () {
      this.isLoadingExplotaciones = true;
      this.showLoading();

      let request = {
        controller: '/Explotacion'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(response => {
          this.allExplotaciones = response.data;
          // Save Org Options to filter after
          this.allExplotacionesOptsFiltered = response.data;
          this.allExplotacionesOpts = response.data;
        })
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.isLoadingExplotaciones = false;
          this.hideLoading();
        });

      this.isLoadingExplotaciones = false;
    },
    triggerSearchModal () {
      this.showDialogSearchExplotacion = true;
    },
    resetDialogSearchExplotacion () {
      this.showDialogSearchExplotacion = false;
      this.selectedExplotacion = null;
    },
    cleanExplotaciones () {
      if (!this.allExplotaciones) return;

      const explotacionesFiltered = this.allExplotacionesOptsFiltered.filter(e => {
        return !this.listExplotaciones
          .map(x => {
            return x.id;
          })
          .includes(e.id);
      });

      this.allExplotaciones = explotacionesFiltered;
      this.allExplotacionesOpts = explotacionesFiltered;
    },
    refillVisibility (visibility) {
      this.visibilidadTodos = visibility;
    },
    refillExplotaciones (empresasList) {
      if (empresasList.length === 0) return;

      this.listExplotaciones = empresasList;
    },
    updateVisibleForAll () {
      this.$emit('updateVisibleForAll', this.visibilidadTodos);
    },
    getExplotacionesIdOnly (explotaciones) {
      return explotaciones.map(explotacion => explotacion.id);
    },
    async saveNewExplotacion () {
      if (!this.selectedExplotacion) return;
      const newSelectedExplotacion = this.selectedExplotacion;
      const listExplotacionesIdOnly = this.getExplotacionesIdOnly(
        this.listExplotaciones
      );
      const newExplotacionId = newSelectedExplotacion.id;
      const explotacionesToSave = [
        ...listExplotacionesIdOnly,
        newExplotacionId
      ];

      await this.saveExplotacion(explotacionesToSave).then(() => {
        this.listExplotaciones.push(newSelectedExplotacion);
        this.resetDialogSearchExplotacion();
      });
    },
    async removeExplotacion () {
      const explotacionToRemoveId = this.selectedDeleteExplotacion.id;
      // Search index explotacion Id from this.listExplotaciones
      const indexExplotacionToRemove = this.listExplotaciones.findIndex(
        explotacion => explotacion.id === explotacionToRemoveId
      );

      if (indexExplotacionToRemove === -1) { this.showError('Ha ocurrido un error, vuelva a intentarlo.'); return; } // Throw error

      // Copy list of explotaciones and Remove explotacion from this.listExplotaciones
      const copyOfListExplotaciones = [...this.listExplotaciones];
      copyOfListExplotaciones.splice(indexExplotacionToRemove, 1);
      const newListExplotacionesIdOnly = this.getExplotacionesIdOnly(
        copyOfListExplotaciones
      );

      await this.saveExplotacion(newListExplotacionesIdOnly).then(() => {
        this.listExplotaciones = copyOfListExplotaciones;
        this.closeModalDeleteExplotacion();
      });
    },
    async saveExplotacion (explotacionesToSave) {
      const ambitoId = this.data.id;

      this.isLoading = true;
      this.showLoading();

      let request = {
        controller: `/Ambito/${ambitoId}/empresa-relationship`,
        filter: {},
        body: explotacionesToSave
      };

      await this.$store
        .dispatch('PF/postSuit', request)
        .then(() => {})
        .catch(err => {
          this.showError(err);
        })
        .finally(() => {
          this.isLoading = false;
          this.hideLoading();
        });
    },
    closeModalDeleteExplotacion () {
      this.showModalDeleteExplotacion = false;
      this.selectedDeleteExplotacion = null;
    },
    triggerDeleteExplotacion (item) {
      this.selectedDeleteExplotacion = item;
      this.showModalDeleteExplotacion = true;
    },
    filterFn (val, update) {
      if (val === '') {
        update(() => {
          this.allExplotaciones = this.allExplotacionesOpts;
        });
        return;
      }

      update(() => {
        const needle = val.toLowerCase();
        this.allExplotaciones = this.allExplotaciones.filter(
          v => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    }
  },
  watch: {
    listExplotaciones: {
      handler: function () {
        this.cleanExplotaciones();
      },
      deep: true
    },
    dataAmbito: {
      handler: function () {
        this.data = this.dataAmbito;

        if (
          Object.entries(this.data).length === 1 &&
          this.data.hasOwnProperty('id')
        ) { return; }

        if (Object.entries(this.data).length > 0) {
          this.refillVisibility(this.dataAmbito.visibleForAll);
          this.refillExplotaciones(this.dataAmbito.empresas);
        }
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.container-table-visibilidad {
  .my-card {
    min-height: 200px;
    .block-action {
      background-color: transparent;
      pointer-events: none;
      opacity: 0.21;
    }
    .input-row {
      padding: 10px 0px;
    }
  }
  &:deep() {
    .q-table__card {
      box-shadow: none;
    }

    .q-field__messages {
      display: contents;
    }
    .q-field__counter {
      padding-left: 4px;
    }

    .q-card__section--vert {
      padding: 0 !important;
    }
  }
}
</style>
